export var expandColumnId = 'expand';
//# sourceMappingURL=table.utils.js.map